// Generated by scripts/update-seeq-icons.js from src/svg/seeq/copy.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcCopy = {
  prefix: 'fak',
  iconName: 'copy' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e988',
    'M773.1 378.9v0l-199.7-194.6c-15.4-15.4-35.8-25.6-61.4-25.6h-327.7c-61.4 0-112.6 51.2-112.6 112.7v634.8c0 61.4 51.2 112.6 112.6 112.7h501.8c61.4 0 112.6-51.2 112.6-112.7v-471c0-20.5-10.2-41-25.6-56.3zM716.8 911.4c0 15.4-15.4 30.7-30.7 30.7h-501.8c-15.4 0-30.7-15.4-30.7-30.7v-634.9c0-15.4 15.4-30.7 30.7-30.7h327.7v163.8c0 15.4 15.4 30.7 30.7 30.7h174.1v471.1zM839.7 0h-501.8c-56.3 0-102.4 41-112.6 97.3 0 10.2 5.1 20.5 15.3 20.5h51.2c10.2-5.1 15.4-10.2 15.4-15.4 5.1-15.4 15.4-20.5 30.7-20.5h501.8c15.4 0 30.7 15.4 30.7 30.7v634.9c0 15.4-10.2 25.6-20.5 30.7-5.1 0-10.2 10.2-10.2 15.4v51.2c0 10.2 10.2 15.4 20.5 15.4 51.2-10.2 92.2-56.3 92.1-112.7v-634.9c0-61.4-46.1-112.6-112.6-112.6z',
  ],
} satisfies IconDefinition;
